import { Component, ChangeDetectorRef, Input } from '@angular/core';
import { AdditionalLocationData } from '@app/cp/shared/models/AdditionalLocationData';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { Align } from "@progress/kendo-angular-popup";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { environment } from '@env/environment';
import { PotentialCustomerBus } from '@app/cp/shared/models/PotentialCustomerBus';
import { BaseAppMComponent } from '@app/cp/shared/base-components/base-app-m.component';
import { GItem } from '@app/cp/shared/models/GItem';
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { CustomerPage } from '@app/cp/shared/models/CustomerPage';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { EquipmentService } from '@app/cp/shared/services/equipment.service';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { GeographyInfoBus } from '@app/cp/shared/models/GeographyInfoBus';
import { PotentialLocationBus } from '@app/cp/shared/models/PotentialLocationBus';
import { SItem } from '@app/cp/shared/models/SItem';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'cp-potential-locations',
    templateUrl: './potential-locations.component.html',
    styleUrls: ['./potential-locations.component.scss']
})
export class PotentialLocationsComponent extends BaseAppMComponent<PotentialLocationBus, CustomerService, AdditionalLocationData, CustomerPage> {
    compLoader: ICPLoader = this as any;
    filteredStates: any[] = [];
    filteredLocationCBOs: GItem[];
    curlocationCBOs: GItem[];
    activeOnly: boolean = true;
    loactionSearchIdValue: any;

    @Input() customerId: number;
    @Input() customerData: PotentialCustomerBus
    @Input() set locationCBOs(inlocationCBOs: GItem[]) {
        this.curlocationCBOs = inlocationCBOs;
        if (inlocationCBOs) {
            if (this.activeOnly) {
                this.filteredLocationCBOs = this.curlocationCBOs.filter(t => t.canSelect === true);
            }
            else {
                this.filteredLocationCBOs = _.cloneDeep(this.curlocationCBOs);
            }
        }
        else { this.filteredLocationCBOs = [] }

        if (this.filteredLocationCBOs.length > 0) {
            this.loactionSearchIdValue = this.filteredLocationCBOs[0].value;
            this.locationSelected(this.loactionSearchIdValue);
        }
    }

    public popUp: boolean = false;
    public anchorAlign: Align = { horizontal: "right", vertical: "bottom" };
    public popupAlign: Align = { horizontal: "right", vertical: "top" };

    depEnv: string;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_data: CustomerService, qry_rd: DQOIReferenceDataQuery, private cd: ChangeDetectorRef, eqs_data: EquipmentService, private svc_inv: InventoryService) {
        super(globals, featureFlagService, qry_rd);
        this.depEnv = environment.deployment;
        this.svc_data = svc_data;
    }

    setForm() {
        this.editForm.patchValue({
            potentialLocationId: this.data.potentialLocationId,
            potentialCustomerId: this.data.potentialCustomerId,
            potentialLocationName: this.data.potentialLocationName,
            quickSearchKey: this.data.quickSearchKey,
            isActive: this.data.isActive,
            emailAddress: this.data.emailAddress,
            workNumber: this.data.workNumber,
            mobileNumber: this.data.mobileNumber,
            faxNumber: this.data.faxNumber,
            notes: this.data.notes,
            insertDt: this.data.insertDt,
            updateDt: this.data.updateDt,
            insertUserId: this.data.insertUserId,
            updateUserId: this.data.updateUserId,
            workExt: this.data.workExt,
            addressLine1: this.data.geographyInfo?.addressLine1,
            addressLine2: this.data.geographyInfo?.addressLine2,
            city: this.data.geographyInfo?.city,
            stateProvince: this.data.geographyInfo?.stateProvince,
            postalCode: this.data.geographyInfo?.postalCode,
            countryCd: this.data.geographyInfo?.countryCd,
        });
    }

    getData() {
        this.compLoader.cpLoader = true;
        this.subs_data = this.svc_data.getPotentialLocation(this.loactionSearchIdValue).subscribe(data => {
            this.data = new PotentialLocationBus(data);
            this.data.geographyInfo = data.geographyInfo;
            this.setForm();
            this.compLoader.cpLoader = false;
        });
    }

    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'potentialLocationId': new UntypedFormControl(),
        'potentialCustomerId': new UntypedFormControl(),
        'potentialLocationName': new UntypedFormControl('', Validators.required),
        'quickSearchKey': new UntypedFormControl(),
        'isActive': new UntypedFormControl(),
        'emailAddress': new UntypedFormControl(),
        'workNumber': new UntypedFormControl(),
        'mobileNumber': new UntypedFormControl(),
        'faxNumber': new UntypedFormControl(),
        'notes': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'workExt': new UntypedFormControl(),
        'addressLine1': new UntypedFormControl("", Validators.required),
        'addressLine2': new UntypedFormControl(),
        'city': new UntypedFormControl("", Validators.required),
        'stateProvince': new UntypedFormControl(null, Validators.required),
        'postalCode': new UntypedFormControl("", Validators.required),
        'countryCd': new UntypedFormControl("", Validators.required),
    });

    locationSelected(id: any) {
        if (id.value) {
            this.loactionSearchIdValue = id.value;
        }
        this.getData();
    }

    public addSelected(always: boolean = true) {
        if (always || !this.data) {
            this.data = {} as PotentialLocationBus;
            this.data.isAdded = true;
            this.data.isActive = true;

            this.data.geographyInfo = {} as GeographyInfoBus;
            this.data.geographyInfo.countryCd = "US";
            this.setForm();
        }
    }

    copyFromCustomer() {
        if (this.customerData) {
            this.editForm.patchValue({
                locationName: this.customerData.potentialCustomerName,
                emailAddress: this.customerData.emailAddress,
                workNumber: this.customerData.workNumber,
                mobileNumber: this.customerData.mobileNumber,
                faxNumber: this.customerData.faxNumber,
                workExt: this.customerData.workExt,
                addressLine1: this.customerData.geographyInfo.addressLine1,
                addressLine2: this.customerData.geographyInfo.addressLine2,
                city: this.customerData.geographyInfo.city,
                stateProvince: this.customerData.geographyInfo.stateProvince,
                postalCode: this.customerData.geographyInfo.postalCode,
            });
        }
    }

    setForSave(): PotentialLocationBus {
        let busObj: PotentialLocationBus = new PotentialLocationBus(this.data);

        busObj.potentialCustomerId = this.customerId;
        busObj.quickSearchKey = this.editForm.value.quickSearchKey;
        busObj.potentialLocationName = this.editForm.value.potentialLocationName;

        busObj.geographyInfo.addressLine2 = this.editForm.value.addressLine2;
        busObj.geographyInfo.addressLine1 = this.editForm.value.addressLine1;
        busObj.geographyInfo.city = this.editForm.value.city;
        busObj.geographyInfo.stateProvince = this.editForm.value.stateProvince;
        busObj.geographyInfo.countryCd = this.editForm.value.countryCd;
        busObj.geographyInfo.postalCode = this.editForm.value.postalCode;

        busObj.workNumber = this.editForm.value.workNumber;
        busObj.workExt = this.editForm.value.workExt;
        busObj.faxNumber = this.editForm.value.faxNumber;
        busObj.mobileNumber = this.editForm.value.mobileNumber;
        busObj.emailAddress = this.editForm.value.emailAddress;

        return busObj;
    }

    saveAll() {
        this.compLoader.cpLoader = true;
        let busSaveObj: PotentialLocationBus = this.setForSave();

        this.svc_data.updatePotentialLocation(busSaveObj).subscribe(data =>{
            if (!data.saveError) {
                this.data = data.potentialLocations;
                this.setForm();
                this.globals.notifySuccess("Potential Location Saved Successfully!")
                this.compLoader.cpLoader = false;
            }
        });
    }

    countryCBOChanged(e: SItem) {
        this.filteredStates = this.referenceData.allStates.filter(t => t.category === e.value)
        if (this.filteredStates.length == 0) { this.filteredStates = this.referenceData.allStates }
    }

    getPotentialLocations(id: any) {
        this.svc_data.getPotentialCustomerLocationsForCBO(id).subscribe(data => {
            this.filteredLocationCBOs = data;
            this.cd.detectChanges();
        });
    }

    ngAfterViewInit() {
        if (this.referenceData && this.referenceData.allStates) {
            this.filteredStates = this.referenceData.allStates
        }
        else {
            setTimeout(() => {
                if (this.referenceData && this.referenceData.allStates) {
                        this.filteredStates = this.referenceData.allStates
                }
            }, 3000);
        }

        this.cd.detectChanges();
    }
}

